import {DELETE, POST, GET} from "@/services/gateway";

const connectAws = (data) => {
  return POST('recovery/destination/awss3/connect', data);
}

const connectAzure = (data) => {
  return POST('recovery/destination/azure/connect', data);
}

const connectS3Compatible = (data) => {
  return POST('recovery/destination/awss3/compatible/connect', data);
}

const connectGoogleCloud = (data) => {
  return POST('recovery/destination/gcp/connect', data);
}

const connectDropbox = (data) => {
  return POST('recovery/destination/dropbox/connect', data);
}

const listConnection = ({storageDestinationType, providerTenantType, pagination}) => {
  // console.log("DATA", data)
  // let test = POST('recovery/destination/list', data);
  return POST('recovery/destination/list', {storageDestinationType, providerTenantType, pagination});
  // console.log("test e", test)
  // return test;
}

const listRegion = () => {
  return GET('recovery/destination/awss3/regions');
}

const listRegionsGCP = () => {
  return GET('recovery/destination/gcp/regions');
}

const deleteConnection = (id) => {
  return DELETE(`recovery/destination`, id)
}

const connectGoogle = (data) => {
  return POST('recovery/destination/google/connect', data);
}

const connectMicrosoft = (data) => {
  return POST('recovery/destination/microsoft/connect', data);
}

const connectBox = (data) => {
  return POST('recovery/destination/box/connect', data);
}

export const editAws = ({ id, accessKey, bucketName, region, secretKey }) => {
  return POST(
    'recovery/destination/awss3/connect/edit',
    { id, accessKey, bucketName, region, secretKey }
  )
}

export const editAzure = ({ id, containerName, accountName, accountKey }) => {
  return POST(
    'recovery/destination/azureblob/connect/edit',
    { id, containerName, accountName, accountKey }
  )
}

export const editS3Compatible = ({ id, accessKey, bucketName, region, secretKey, endpointUrl }) => {
  return POST(
    'recovery/destination/awss3/compatible/connect/edit',
    { id, accessKey, bucketName, region, secretKey, endpointUrl }
  )
}

export const editGoogleCloud = ({ id, accessKey, bucketName, region, secretKey }) => {
  return POST(
    'recovery/destination/gcp/connect/edit',
    { id, accessKey, bucketName, region, secretKey }
  )
}

export {
  connectAzure,
  connectAws,
  connectDropbox,
  connectS3Compatible,
  connectGoogleCloud,
  listRegion,
  listRegionsGCP,
  listConnection,
  deleteConnection,
  connectGoogle,
  connectMicrosoft,
  connectBox
}
